var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex p10"},[_c('div',{staticClass:"w99 f13 f-grey pt10"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"flex-center"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }